class SubscriptionBenefits extends HTMLElement {
  constructor() {
    super()
    this.subscriptionBenefits = this.dataset.subscriptionBenefits;
  }

  connectedCallback() {
    if (this.subscriptionBenefits) {
      this.subscriptionBenefits = JSON.parse(this.subscriptionBenefits);
      const markup = this.subscriptionBenefits.map(benefit => {
        const itemMarkup = `
          <p class="product-subscription-benefit">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
              <path d="M6.31572 13H6.30907C6.26622 12.9992 6.22399 12.9899 6.18491 12.9729C6.14584 12.9558 6.11073 12.9313 6.0817 12.9008L0.0839557 6.58917C0.034075 6.53669 0.0045723 6.46908 0.00048897 6.39789C-0.00359436 6.32669 0.0179951 6.25634 0.0615683 6.19884C0.105156 6.14136 0.167998 6.10028 0.239378 6.08263C0.310758 6.06497 0.386256 6.07183 0.452999 6.10202L5.94247 8.58957C5.98865 8.61056 6.04322 8.6004 6.07855 8.56486L14.4522 0.0950596C14.5655 -0.0197036 14.7509 -0.0322294 14.8796 0.0666227C15.0083 0.165475 15.0381 0.342867 14.9482 0.475911L6.61865 12.825C6.60675 12.8429 6.59276 12.8592 6.57737 12.8744L6.54064 12.91C6.48086 12.9675 6.40003 12.9999 6.31572 13Z" fill="#030303"/>
            </svg>
            <span>${benefit}</span>
          </p>
        `

        return itemMarkup;
      })

      this.observerInit(markup)
    }
  }

  observerInit(markup) {
    const selector = '.Avada-Subscription__Description-Item';

    function onElementFound(el) {
      setTimeout(() => {
        el.innerHTML = markup.join('');

        const allCantainersForBullets = document.querySelectorAll('.Avada-ModernSelectionBox-Label');

        allCantainersForBullets.forEach(container => {
          const div = document.createElement('div');
          div.classList.add('product-subscription-benefit-bullet');

          container.insertAdjacentElement('afterbegin', div);
        })
      }, 1000)
    }

    const initial = document.querySelector(selector);
    if (initial) {
      onElementFound(initial);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches(selector)) {
              onElementFound(node);
              obs.disconnect();
              return;
            }

            const found = node.querySelector && node.querySelector(selector);
            if (found) {
              onElementFound(found);
              obs.disconnect();
              return;
            }
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
}

customElements.define('subscription-benefits', SubscriptionBenefits)